import React from "react";
import AccountProfileDetail from "../../components/screen/profile/AccountProfileDetail";
import SidebarComponents from "../../components/ui/SidebarComponents";
import Header from "../../components/ui/Header";
import { SIDEBAR_WIDTH } from "../../components/constants/constant";

const AccountProfileDetailPage = () => {
  return (
    <div className="">
      <div className="flex">
          <SidebarComponents />       
        <div className={`w-[100%] lg:w-[calc(100%-${SIDEBAR_WIDTH}px)] p-3 overflow-hidden`}>
          <Header />
          <AccountProfileDetail />
        </div>
      </div>
    </div>
  );
};

export default AccountProfileDetailPage;
